import { createConfig, http } from 'wagmi';
import { sepolia, mainnet } from 'wagmi/chains';
import { injected, metaMask, safe, walletConnect } from 'wagmi/connectors'
import { coinbaseWallet } from '@wagmi/connectors'
const projectId = '549ef9806a7268b35975a1bbee557640';
export const config = createConfig({
  chains: [mainnet], 
  connectors: [
    walletConnect({ projectId }),
    metaMask(),
    coinbaseWallet(),
  ],
  transports: {
    [mainnet.id]: http(),
  },
});
